module.exports = __webpack_public_path__ + "static/media/IconArrowDown.e104e992.svg";